;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/test\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.0.10";import * as Sentry from "@sentry/nextjs";
import { publicEnv } from "./lib/env-config";

Sentry.init({
  dsn: publicEnv.sentryDsn,
  environment: publicEnv.vercelEnv ?? publicEnv.nodeEnv,
  tracesSampleRate: publicEnv.nodeEnv === "development" ? 1.0 : 0.1,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
